/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const Condition = require('./Condition');
const DamageEvent = require('../events/DamageEvent');
const { logError } = require('../logger');

const PoisonedCondition = function (
  instigator,
  owner,
  battleState,
  potency,
  charges
) {
  const condition = new Condition(
    instigator,
    owner,
    battleState,
    potency,
    charges
  );
  condition.handle = 'poisoned';
  condition.ConditionClass = PoisonedCondition;

  condition.applyPoison = function () {
    try {
      if (owner.dead || !battleState || !battleState.allUnits) {
        this.expire();
        return;
      }

      if (battleState.paused) {
        return;
      }

      // apply poison damage
      const damageEvent = new DamageEvent(
        battleState,
        this.instigator,
        this.potency,
        this
      );
      damageEvent.execute(battleState.allUnits[this.ownerId], false);

      // decrement potency
      this.potency *= 0.7;
      if (this.potency <= 5) {
        this.expire();
      }
    } catch (err) {
      logError(err, {
        module: 'PoisonedCondition',
        func: 'applyPoison',
        instigator,
        owner,
        battleState,
        potency,
        charges,
      });
    }
  };

  condition.initInterval(condition.applyPoison, 1000);
  if (battleState.paused) {
    condition.intervalTimer.pause();
  }

  return condition;
};

PoisonedCondition.fromCopy = function(cState, owner, instigator, battleState) {
  return PoisonedCondition(instigator, owner, battleState, cState.potency, cState.charges);
};

module.exports = PoisonedCondition;
